// extracted by mini-css-extract-plugin
export default {"component":"SelfEmployedAlert_component__tUu37","list":"SelfEmployedAlert_list__AQ+3b","listItem":"SelfEmployedAlert_listItem__WWrCS"};